const namespaceLogin = '[Login]';

export const LOGIN_SUCCESS = `${namespaceLogin} LOGIN_SUCCESS`;
export const LOGIN_FAILED = `${namespaceLogin} LOGIN_FAILED`;
export const LOGIN_UPDATE_TOKEN = `${namespaceLogin} LOGIN_UPDATE_TOKEN`;
